module.exports = __webpack_public_path__ + "static/media/Genesis.31d6074d.jpeg";